var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClipboardMedical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2.5H8.8125C8.375 1.34375 7.28125 0.5 6 0.5C4.6875 0.5 3.59375 1.34375 3.15625 2.5H1.5C0.65625 2.5 0 3.1875 0 4V15C0 15.8438 0.65625 16.5 1.5 16.5H10.5C11.3125 16.5 12 15.8438 12 15V4C12 3.1875 11.3125 2.5 10.5 2.5ZM6 2.5C6.53125 2.5 7 2.96875 7 3.5C7 4.0625 6.53125 4.5 6 4.5C5.4375 4.5 5 4.0625 5 3.5C5 2.96875 5.4375 2.5 6 2.5ZM9 11C9 11.2812 8.75 11.5 8.5 11.5H7V13C7 13.2812 6.75 13.5 6.5 13.5H5.5C5.21875 13.5 5 13.2812 5 13V11.5H3.5C3.21875 11.5 3 11.2812 3 11V10C3 9.75 3.21875 9.5 3.5 9.5H5V8C5 7.75 5.21875 7.5 5.5 7.5H6.5C6.75 7.5 7 7.75 7 8V9.5H8.5C8.75 9.5 9 9.75 9 10V11Z",
    fill: "#AAB0B3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardMedical);
export default __webpack_public_path__ + "static/media/clipboard-medical.00f83d35.svg";
export { ForwardRef as ReactComponent };